import { BaseEntity } from './base-entity';
import { Scale } from './scale';
import { WegweiserIndicator } from '../services/grid-widget-config.service';
import { units } from './unit';

export interface BaseIndicator {
  name: string;
  unit: string;
}

export interface Indicator extends BaseEntity, BaseIndicator {
  type: 'indicator'; // discriminant for WegweiserIndicator
  key: string;
  category: string;
  categorical: boolean;
  prefix?: string;
  locked?: boolean;
  tags?: Array<string>;
  products?: Array<string>;
  decimals?: number;
  defaultColorSet?: string;
  defaultInvert?: boolean;
  indication?: string;
  hint?: string;
  source?: string;
  statement?: string;
  calculation?: string;
  sorting: number;
  dataCycle?: string;
  levelOfAvailability?: string;
  legendMode?: string;
  legend?: Array<Scale>;
  dataSupplier?: string;
  parent?: string;
  isSet?: boolean;
  pool?: boolean;
  workspaces?: string[];
}

type UnitType = 'short' | 'long' | 'symbol';

export function getUnit(
  indicator: BaseIndicator,
  type: UnitType = 'short'
): string {
  return getIndicatorUnit(indicator, type);
}

function getIndicatorUnit(indicator: BaseIndicator, type: UnitType): string {
  if (isIndicator(indicator)) {
    const unit = units[indicator.unit];
    return unit ? (unit[type] ?? '') : '';
  }
  return indicator.unit;
}

export function isIndicator(indicator: BaseIndicator): indicator is Indicator {
  return !!(indicator as Indicator).key;
}

export function isWegweiserIndicator(
  indicator: BaseIndicator
): indicator is WegweiserIndicator {
  if (!indicator) return false; // Ensure indicator is not null or undefined
  return !(indicator as Indicator).key;
}

export function getIconByIndicatorType(isSet: boolean) {
  return isSet ? 'fas fa-ruler-combined' : 'fas fa-ruler-vertical';
}

export const xlsxColumnProperties: string[] = [
  'name',
  'key',
  'calculation',
  'unit',
  'decimals',
  'products',
  'tags',
  'category',
  'indication',
  'statement',
  'source',
  'defaultColorSet',
  'legend',
  'hint',
  'dataCycle',
  'levelOfAvailability',
  'dataSupplier',
  'isSet',
  'parent',
  'locked',
];
